<template>
  <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
    <template v-slot:searchDiv>
      <div class="secondSearchLine">
        <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
        <el-select v-model="searchObj.location" placeholder="请选择" size="mini" style="width: 1.3rem">
          <el-option v-for="item in restaurantOptionsOne" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="searchObj.location" placeholder="请选择" size="mini" style="width: 1.3rem">
          <el-option v-for="item in restaurantOptionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="searchObj.location" placeholder="请选择" size="mini" style="width: 1.3rem">
          <el-option v-for="item in restaurantOptionsThree" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </template>
    <template v-slot:contentDiv>
      <div v-for="(item,index) in dataList" :key="index">
        <div v-if="item.productType==2">
          <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
        </div>
        <div v-else-if="item.productType==3" class="product_body">
          <hotel-resource-left :productObj="item" :showTag="false" :priceNullStr="'单点'" @exclusiveAddYsP="exclusiveAddYsP(item)"></hotel-resource-left>
        </div>
        <custom v-else :item="item" :chenckBudgteObj="$refs.stock.budget" :keyStr="keyStr" class="contentDiv"></custom>
      </div>
    </template>
  </stock>
</template>

<script>
import Stock from './stock.vue'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import { refresh } from '../../js/function'
import Custom from './custom.vue'
export default {
  components:{Stock,hotelResourceLeft,Custom},
  data(){
    return{
       searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:[],
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:4,
      },
      restaurantOptionsOne: [
        {
          value: "",
          label: "餐厅风格",
        },
      ],
      restaurantOptionsTwo: [
        {
          value: "",
          label: "餐厅口味",
        },
      ],
      restaurantOptionsThree: [
        {
          value: "",
          label: "餐厅类型",
        },
      ],
      dataList:[],
      keyStr:'',
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    exclusiveAddYsP(item){
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:4,
        startLinkId:this.searchObj.cityId,
        startLinkName:this.searchObj.cityNameCn,
        startLinkNameEn:this.searchObj.cityNameEn,
        linkType:1,
        stayDate:this.searchObj.date,
        productType:7,
        resourceId:item.id,
        resourceNameCn:item.nameCn,
        resourceNameEn:item.nameEn,
        key:this.keyStr,
        details:[]
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    postListData(type){
      if(this.checkState===4){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.product_body{
  background: #fff;
  border: 1px solid #f54402;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  margin: 0.1rem 0;
  padding: 0.1rem 0 0 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0,0.4);
}
.secondSearchLine{
  /deep/ .el-range-separator{
    transform: translateX(-4px);
  }
  .date{
    margin-left: 0.1rem;
  }
  /deep/ .el-select{
    margin-left: 0.1rem;
    width: 1rem;
  }
}
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentHead{
    display: flex;
    justify-content: space-between;
    border-bottom: 3px solid #db4e1a;
    .head_left{    
      /deep/ .showCard-imgBox{
        margin-left: 0;
        img{
          margin: 0 0.05rem;
        }
      }
    }
    .head_right{
      .cardContainer{
        background: #f1f4f4;
        width: 1.3rem;
      }
      .cardContainer-oneBox{
        padding: 0.05rem 0.1rem 0.05rem 0.05rem;
        .btn{
          cursor: pointer;
          display: inline-block;
          background: #5677fc;
          color: #fff;
          padding: 0.03rem 0.15rem;
          font-size: 0.12rem;
        }
        .cardContainer-twoBox{
          margin-top: 0.1rem;
          .circle{
            i{
              font-size: 0.2rem;
              color: #333;
            }
          }
          .fractionBox{
            >b{
              color: #d81b43;
              font-size: 0.16rem;
              margin:0 0.05rem;
            }
            >span{
              font-weight: bold;
              color: #676976;
              font-size: 0.12rem;
            }
          }
        }
      }
      .showCard-tag{
        padding: 0 0.04rem;
        height: 0.35rem;
        background: #db4e1a;
        display: flex;
        align-items: center;
        margin-top: 0.05rem;
        justify-content: space-between;
        cursor: pointer;
        color: #fff; 
        >div{
          >i{
            font-size: 0.25rem;
          }
          >b{
            font-size: 0.18rem;
          }
          >label{      
            font-size: 0.12rem;
            padding-right: 3px;
          }
        }
      }
    }
  }
  .contentContainer{
    .boxContainer1{
      font-size: 0.12rem;
      margin-top: 0.1rem;
      margin-left: 0.1rem;    
      .firstLine{
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .productName{
        font-size: 0.125rem;
        width: 1.4rem;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item1{
        margin-left: 0.1rem;
        display: flex;
        align-items: center;
        .item2{
          margin-left: 0.2rem;
          display: flex;
          align-items: center;
          >span{
            color: #ff0000;
            font-size: 0.16rem;
            text-decoration: underline;
            width: 1rem;
          }
        }
        .tagBox{
          margin-left: 0.4rem;
          >span{
            font-size: 0.14rem;
            font-weight: normal;
          }
        }
      }
      .item3{
        margin-left: 0.3rem;
        display: flex;
        .qiang{
          font-size: 0.18rem;
          box-shadow: 0px 0px 4px 0px #333;
          border-radius: 50%;
          color: red;
          text-align: center;
          display: inline-block;
          width: 0.26rem;
          height: 0.26rem;
          margin: 1px;
          vertical-align: middle;
          margin-right: 0.05rem;
        }
        >i{
          font-size: 0.28rem;
        }
      }
      .box2{
        display: flex;
        margin-top: 0.1rem;
        .item1{
          >span:first-child{
            color: #db4e1a;
            font-weight: bold;
            margin-left: 1.4rem;
            width: 0.6rem;
          }
          >span:last-child{
            margin-left: 0.1rem;
            width: 3.55rem;
          }
        }
        .item2{
          cursor: pointer;
          margin-left: 0.3rem;
          color: #db4e1a;
        }
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>